import React, { useState, ChangeEvent, useEffect } from "react"
import ModalWrap from './index';
import styles from "./Modal.module.css"
import http from '../../Service/http';
import BlueBtn from "../SidBarButtons/BlueBtn";
import { getDescriptionTeacher } from "../../Service/properties";
import { updDescriptionTeacher } from '../../Service/properties';
import { AiFillBell } from "react-icons/ai"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaSave } from "react-icons/fa"
import { teacher } from './../../store/teacher';
import { teacherProperty } from './../../store/teacherProperty';
import { auth } from "../../store/auth";

type NotesModalPropType = {
    close: () => void
    modal: boolean
    id?: number
}

function NoteseTeacherModal( { close, modal, id }: NotesModalPropType ) {

    const notify = (title:string) => toast(title);
    const [ description, setDescription ] = useState<string>("")

    const saveDesc = async () => {
        if(id == 0){
            const res = await http.post("/teacher/description-teacher", {
                id_teacher: teacher.teacher.id_teacher, 
                id_user: auth.user.data.id, 
                okno_description: description
            })
            if( res.data.result ){
                const oknoDesc = await getDescriptionTeacher(teacher.teacher.id_teacher)
                teacherProperty.newDescription(oknoDesc)
                notify("Успешно добавлено!")
            }
            return
        }else{
            if(id){
                const res = await updDescriptionTeacher( id, teacher.teacher.id_teacher, description)
                if( res ){
                    const oknoDesc = await getDescriptionTeacher(teacher.teacher.id_teacher)
                    teacherProperty.newDescription(oknoDesc)
                    notify("Успешно обновлен!")
                }
            }
        }
    }

    const currentDesc = async(id: number) => {
        const desc = await teacherProperty.desription.find(item => item.id_okno_description_teacher = id)
        if( desc ){
            setDescription(desc.okno_description)
        }
    }

    useEffect(() => {
        if(id)currentDesc(id)
    }, [id])
    return ( 
        <>
            <ModalWrap setIsOpen={() => {
                setDescription('')
                close()
                }} title={"Примечание"}  isOpen={modal} id={23} >
                <textarea value={ description } onChange={(e:ChangeEvent<HTMLTextAreaElement>) => {
                    setDescription(e.target.value)
                }} className={styles.textArea} rows={12}>
                </textarea>
                <div className="container">
                    <div className="demo-flex-spacer">
                    </div>
                    
                </div>
                <div className={styles.btnWrap} > 
                    {
                        description? <BlueBtn title="Сохранить" onclick={saveDesc}>
                            <FaSave />
                        </BlueBtn>:
                        <button className={styles.btn}  onClick={() => {
                        }}> <AiFillBell className={styles.btnIcon}/> Отмена </button>    
                    } 
                </div>
            </ModalWrap>
        </>
     );
}

export default NoteseTeacherModal;